import IframePopup from '@/views/IframePopup/index.vue'

const IframePopupRouter = {
  path: '/popup',
  name: 'IframePopup',
  component: IframePopup,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default IframePopupRouter
